
/* @ngInject */
class AuthenticationService {
    constructor(HPConfig, $q, $injector, AuthenticationFactory) {
        this.HPConfig = HPConfig;
        this.$q = $q;
        this.AuthenticationFactory = AuthenticationFactory;
        this.$injector = $injector;

        this.serviceBase = this.HPConfig.authApi;
        this.$http = null;
    }

    logOut() {
        this.AuthenticationFactory.removeAuthenticationData();
    }

    refreshToken() {
        const deferred = this.$q.defer();

        const authData = this.AuthenticationFactory.getAuthenticationData();

        if (authData && authData.useRefreshTokens) {
            const data = `grant_type=refresh_token&refresh_token=${authData.refresh_token}&client_id=${this.HPConfig.applicationSource}`;

            this.AuthenticationFactory.removeAuthenticationData();

            this.$http = this.$http || this.$injector.get('$http');
            this.$http.post(`${this.serviceBase}token`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }).then((response) => {
                response.data.useRefreshTokens = true;
                this.AuthenticationFactory.setAuthenticationData(response.data);

                deferred.resolve(response.data);
            }).error((err) => {
                this._logOut();
                deferred.reject(err);
            });
        } else {
            deferred.reject();
        }

        return deferred.promise;
    }
}

export default ['HPConfig', '$q', '$injector', 'AuthenticationFactory', AuthenticationService];




// WEBPACK FOOTER //
// ./src/app/common/userAuthorization/authentication.service.js